import React from 'react';
import { Button } from '../../components/ui';
import { Loading } from '../../components/blocks';
import { useResubscribe } from '../../mutation/unsubscribe';
import { useUnsubscribeStore } from './store';

export default function ResubscriptionButton() {
  const { isLoading, error, mutateAsync } = useResubscribe();
  const { currentToken, setResubscribed } = useUnsubscribeStore();
  return (
    <div>
      <span>
        If you clicked unsubscribe by mistake, you can re-subscribe by clicking
        the button below
      </span>
      <br />
      &nbsp;
      <br />
      {Boolean(error) && (
        <span className="error">
          Unable to complete request. Please try again later.
        </span>
      )}
      <Button
        className="re-subscribe-button"
        disabled={isLoading}
        type="primary"
        onClick={() =>
          mutateAsync({ ui: currentToken })
            .then(() => {
              setResubscribed(true);
            })
            .catch(() => {})
        }
      >
        Re-subscribe
        {isLoading && <Loading size={10} />}
      </Button>
    </div>
  );
}
